import { render, staticRenderFns } from "./teamIntroduction.vue?vue&type=template&id=bc0c7ba2&scoped=true"
import script from "./teamIntroduction.vue?vue&type=script&lang=js"
export * from "./teamIntroduction.vue?vue&type=script&lang=js"
import style0 from "./teamIntroduction.vue?vue&type=style&index=0&id=bc0c7ba2&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./teamIntroduction.vue?vue&type=style&index=1&id=bc0c7ba2&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0c7ba2",
  null
  
)

export default component.exports